import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useHeadshot } from "@hooks/useHeadshot";
import { getPlayerGPSData, setPlayerFilter } from "@store/actions/player.actions";
import { useStatusTrackerV2 } from "../hooks/useStatusTrackerV2";
import { selectCurrentCells, selectPlayerCells, computeStatusCounts } from "../state/selectors";
import { PlayerCardView } from "../views/PlayerCardView";

// Container for the fixed player column: headshot + per-player status counts + redirect.
const PlayerColumnCellInner = ({ player }) => {
    const dispatch = useDispatch();
    const { state, team } = useStatusTrackerV2();
    const headshotSrc = useHeadshot(player);

    const counts = useMemo(() => {
        const cells = selectCurrentCells(state);
        const playerCells = selectPlayerCells(cells, player.player_id);
        return computeStatusCounts(playerCells, state.statuses);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.byMonth, state.statuses, state.filters.selectedMonth, player.player_id]);

    const onRedirect = () => {
        if (player.player_id) {
            dispatch(setPlayerFilter({ player: player.player_id }));
            dispatch(getPlayerGPSData());
        }
    };

    return (
        <Link style={{ color: "black" }} to={{ pathname: "/playerdata" }} onClick={onRedirect}>
            <PlayerCardView
                player={player}
                headshotSrc={headshotSrc}
                teamLogo={team.info.team_logo}
                counts={counts}
            />
        </Link>
    );
};

export const PlayerColumnCell = React.memo(PlayerColumnCellInner);
